import styled from 'styled-components';

export const ViewAllButtonContainer = styled.div`
  border-radius: 2px;
  border: solid 0.5px rgb(0 0 0 / 38%);
  height: 46px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 800px;
  margin: 40px auto;
  font-size: clamp(14px, 2vw, 16px);
  font-weight: 600;
  text-align: center;
  color: hsl(0deg, 0%, 0%, 80%);
  transition: all 0.2s ease-in-out;
  cursor: pointer;

  &:hover {
    background-color: #ef4e5e;
    color: #fff;
    border: none;
  }

  @media (max-width: 720px) {
    width: calc(100% - 20px);
    margin: 20px auto;
    cursor: default;
    height: ${(props) => (props.isCategoryPage ? '36px' : '46px')};
    font-size: ${(props) =>
      props.isCategoryPage
        ? 'clamp(12px, 2vw, 16px)'
        : 'clamp(14px, 2vw, 16px)'};
  }
`;

export const ViewAllButtonVerm = styled(ViewAllButtonContainer)`
  border: 1px solid #ef4e5e;
  color: #ef4e5e;
  max-width: ${(props) => props.width};
  position: relative;
  overflow: hidden;

  span.ripple {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    animation: rippleB 600ms linear;
    background-color: rgba(255, 255, 255, 0.7);
  }

  @keyframes rippleB {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }
`;
